/* ============================================================
   bellia — koszyk (drawer)
   Render pozycji z /cart.js, ilości, usuwanie, ochrona przesyłki,
   licznik rezerwacji, przechwycenie ikony koszyka i /cart/add.
   ============================================================ */
(function () {
  'use strict';

  var root, panel, overlay, itemsEl, scrollEl, emptyEl, footEl, countEl, subtotalEl, timerEl, protectInput;
  var savingsEl, savingsValueEl, upsellEl, upsellSelect, upsellImg;
  var moneyFormat, protectionVariant, reserveMinutes, upsellHandle;
  var cartState = null;
  var grupyStanu = {};   // wiersz koszyka -> wszystkie linie Shopify tego samego wariantu
  var timerInterval = null;
  var productCache = {};

  /* ---------- ceny przed obniżką (cart.js ich nie zwraca) ---------- */
  function loadCompareData(cart) {
    var handles = [];
    cart.items.forEach(function (i) {
      if (i.handle && !productCache[i.handle] && handles.indexOf(i.handle) === -1) handles.push(i.handle);
    });
    if (!handles.length) return Promise.resolve();
    return Promise.all(handles.map(function (h) {
      return fetch('/products/' + h + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) { if (p) productCache[h] = p; })
        .catch(function () {});
    }));
  }

  function compareUnitOf(item) {
    var p = productCache[item.handle];
    if (!p) return 0;
    var v = null;
    for (var i = 0; i < p.variants.length; i++) {
      if (p.variants[i].id === item.variant_id) { v = p.variants[i]; break; }
    }
    if (!v || !v.compare_at_price) return 0;
    return v.compare_at_price > item.price ? v.compare_at_price : 0;
  }

  function formatMoney(cents, format) {
    var amount = (cents / 100).toFixed(2);
    var withComma = amount.replace('.', ',');
    var f = format || '{{amount_with_comma_separator}} zł';
    return f
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withComma)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100).toString())
      .replace(/\{\{\s*amount\s*\}\}/, amount);
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function plural(n) {
    if (n === 1) return 'produkt';
    var d = n % 10, h = n % 100;
    if (d >= 2 && d <= 4 && (h < 12 || h > 14)) return 'produkty';
    return 'produktów';
  }

  function imgUrl(src, size) {
    if (!src) return '';
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + size;
  }

  /* ---------- zestaw z kodem rabatowym (1+1, 2+2, 3+3) ---------- */
  // Kod „kwota rabatu” Shopify rozkłada po równo na pary (1+1 za 109 zł = 2 × 54,50 zł),
  // co klientki odbierały jako dziwne ceny. Pokazujemy cały zestaw jednym wierszem.
  var ZESTAWY_ZAPASOWE = {
    AB11: { label: '1 + 1 GRATIS', qty: 2, was_unit: 10900 },
    AB22: { label: '2 + 2 GRATIS', qty: 4, was_unit: 10900 },
    AB33: { label: '3 + 3 GRATIS', qty: 6, was_unit: 10900 },
    BL22: { label: '2 + 2 GRATIS', qty: 4 },
    BL33: { label: '3 + 3 GRATIS', qty: 6 }
  };

  function kodLinii(item) {
    var a = (item.line_level_discount_allocations || []).find(function (d) {
      return d.discount_application && d.discount_application.type === 'discount_code';
    });
    return a ? String(a.discount_application.title || '') : '';
  }

  function znajdzZestaw(cart) {
    var kod = '';
    cart.items.forEach(function (i) {
      if (!kod && !(protectionVariant && i.variant_id === protectionVariant)) kod = kodLinii(i);
    });
    if (!kod) return null;
    var info = null;
    try {
      var zapis = JSON.parse(sessionStorage.getItem('blZestaw') || 'null');
      if (zapis && String(zapis.code).toUpperCase() === kod.toUpperCase()) info = zapis;
    } catch (e) {}
    if (!info) info = ZESTAWY_ZAPASOWE[kod.toUpperCase().slice(0, 4)] || null;
    if (!info) return null;

    var linie = cart.items.filter(function (i) {
      return !(protectionVariant && i.variant_id === protectionVariant) && kodLinii(i).toUpperCase() === kod.toUpperCase();
    });
    var sztuk = linie.reduce(function (s, i) { return s + i.quantity; }, 0);
    if (sztuk !== info.qty) return null; // klientka dołożyła/zdjęła sztuki — zwykły widok

    var pary = {}, kolejnosc = [];
    linie.forEach(function (i) {
      if (!pary[i.variant_id]) { pary[i.variant_id] = { title: i.variant_title, qty: 0 }; kolejnosc.push(i.variant_id); }
      pary[i.variant_id].qty += i.quantity;
    });
    var oryginal = linie.reduce(function (s, i) { return s + i.original_line_price; }, 0);
    var zapas = ZESTAWY_ZAPASOWE[kod.toUpperCase().slice(0, 4)] || {};
    var was = zapas.was_unit ? zapas.was_unit * sztuk : oryginal;
    return {
      label: info.label,
      item: linie[0],
      keys: linie.map(function (i) { return i.key; }),
      qty: sztuk,
      final: linie.reduce(function (s, i) { return s + i.final_line_price; }, 0),
      was: was,
      doplata: was - oryginal,
      opis: kolejnosc.map(function (id) {
        var p = pary[id];
        return (p.qty > 1 ? p.qty + ' × ' : '') + esc(p.title);
      })
    };
  }

  /* ---------- render ---------- */
  function render(cart) {
    cartState = cart;
    var hasItems = cart.item_count > 0;

    countEl.textContent = hasItems ? cart.item_count + ' ' + plural(cart.item_count) : '';
    emptyEl.hidden = hasItems;
    footEl.hidden = !hasItems;
    if (scrollEl) scrollEl.style.display = hasItems ? '' : 'none';
    subtotalEl.textContent = formatMoney(cart.total_price, moneyFormat);

    var protectionInCart = false;
    var upsellInCart = false;
    var savings = 0;
    var html = '';
    // Shopify dzieli ten sam wariant na kilka linii, gdy dziala rabat 2+1 / 3+2
    // (sztuka gratis to osobna linia za 0 zl). Klientka widziala wtedy 2-3 takie same
    // pozycje z wylaczonym "−" i myslala, ze koszyk blokuje zmiane ilosci
    // (zgloszenie 2026-10-22). Laczymy je w jeden wiersz z laczna iloscia.
    grupyStanu = {};
    var grupy = [];
    var zestaw = znajdzZestaw(cart);
    if (zestaw) {
      grupyStanu['zestaw'] = zestaw;
      if (zestaw.doplata > 0) savings += zestaw.doplata;
      html +=
        '<div class="bl-cart-item" data-key="zestaw">' +
          '<div class="bl-cart-item-img">' +
            (zestaw.item.image ? '<img src="' + esc(imgUrl(zestaw.item.image, 200)) + '" alt="' + esc(zestaw.item.product_title) + '" loading="lazy">' : '') +
          '</div>' +
          '<div>' +
            '<div class="bl-cart-item-top">' +
              '<a class="bl-cart-item-title" href="' + esc(zestaw.item.url) + '">' + esc(zestaw.item.product_title) + ' · Zestaw ' + esc(zestaw.label) + '</a>' +
              '<button type="button" class="bl-cart-item-remove" data-bl-remove aria-label="Usuń zestaw z koszyka">' +
                '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="M4 7h16M9 7V5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2M6.5 7l1 12.2a1.5 1.5 0 0 0 1.5 1.3h6a1.5 1.5 0 0 0 1.5-1.3l1-12.2M10 11v6M14 11v6"/></svg>' +
              '</button>' +
            '</div>' +
            '<p class="bl-cart-item-variant">' + zestaw.opis.join('<br>') + '</p>' +
            '<div class="bl-cart-item-bottom">' +
              '<span></span>' +
              '<span class="bl-cart-item-price">' +
                (zestaw.was > zestaw.final ? '<s class="bl-cart-item-was">' + formatMoney(zestaw.was, moneyFormat) + '</s> ' : '') +
                '<span class="bl-cart-item-now">' + formatMoney(zestaw.final, moneyFormat) + '</span>' +
              '</span>' +
            '</div>' +
          '</div>' +
        '</div>';
    }
    cart.items.forEach(function (item) {
      if (zestaw && zestaw.keys.indexOf(item.key) > -1) return;
      if (upsellHandle && item.handle === upsellHandle) upsellInCart = true;
      var compareUnit = compareUnitOf(item);
      if (compareUnit) savings += (compareUnit - item.price) * item.quantity;
      // cena sprzed rabatu: z ceny porównawczej albo z rabatu automatycznego Shopify
      var wasLine = compareUnit ? compareUnit * item.quantity : 0;
      if (!wasLine && item.original_line_price > item.final_line_price) wasLine = item.original_line_price;
      if (protectionVariant && item.variant_id === protectionVariant) {
        protectionInCart = true;
        return; // ochrona przesyłki ma własny moduł w stopce
      }
      var variantBits = [];
      if (item.variant_title) variantBits.push(esc(item.variant_title));
      if (item.properties) {
        Object.keys(item.properties).forEach(function (k) {
          if (k.charAt(0) === '_' || !item.properties[k]) return;
          variantBits.push(esc(k) + ': ' + esc(item.properties[k]));
        });
      }
      var id = item.variant_id + '|' + variantBits.join('|');
      var g = grupyStanu['g:' + id];
      if (!g) {
        g = { item: item, keys: [], qty: 0, final: 0, was: 0, bits: variantBits };
        grupyStanu['g:' + id] = g;
        grupy.push({ id: 'g:' + id, g: g });
      }
      g.keys.push(item.key);
      g.qty += item.quantity;
      g.final += item.final_line_price;
      g.was += wasLine || item.final_line_price;
    });

    grupy.forEach(function (wpis) {
      var g = wpis.g, item = g.item;
      html +=
        '<div class="bl-cart-item" data-key="' + esc(wpis.id) + '">' +
          '<div class="bl-cart-item-img">' +
            (item.image ? '<img src="' + esc(imgUrl(item.image, 200)) + '" alt="' + esc(item.product_title) + '" loading="lazy">' : '') +
          '</div>' +
          '<div>' +
            '<div class="bl-cart-item-top">' +
              '<a class="bl-cart-item-title" href="' + esc(item.url) + '">' + esc(item.product_title) + '</a>' +
              '<button type="button" class="bl-cart-item-remove" data-bl-remove aria-label="Usuń z koszyka">' +
                '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="M4 7h16M9 7V5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2M6.5 7l1 12.2a1.5 1.5 0 0 0 1.5 1.3h6a1.5 1.5 0 0 0 1.5-1.3l1-12.2M10 11v6M14 11v6"/></svg>' +
              '</button>' +
            '</div>' +
            (g.bits.length ? '<p class="bl-cart-item-variant">' + g.bits.join('<br>') + '</p>' : '') +
            '<div class="bl-cart-item-bottom">' +
              '<div class="bl-cart-qty">' +
                '<button type="button" data-bl-qty="-1" aria-label="Zmniejsz ilość"' + (g.qty <= 1 ? ' disabled' : '') + '>−</button>' +
                '<span>' + g.qty + '</span>' +
                '<button type="button" data-bl-qty="1" aria-label="Zwiększ ilość">+</button>' +
              '</div>' +
              '<span class="bl-cart-item-price">' +
                (g.was > g.final ? '<s class="bl-cart-item-was">' + formatMoney(g.was, moneyFormat) + '</s> ' : '') +
                '<span class="bl-cart-item-now">' + formatMoney(g.final, moneyFormat) + '</span>' +
              '</span>' +
            '</div>' +
          '</div>' +
        '</div>';
    });
    itemsEl.innerHTML = html;
    if (protectInput) protectInput.checked = protectionInCart;

    // rabaty automatyczne Shopify (np. reguły „1+1", „2+2") liczą się do oszczędności
    savings += cart.total_discount || 0;

    // ile klient oszczędza
    if (savingsEl && savingsValueEl) {
      if (savings > 0) {
        savingsValueEl.textContent = '−' + formatMoney(savings, moneyFormat);
        savingsEl.hidden = false;
      } else {
        savingsEl.hidden = true;
      }
    }

    // upsell: pokaż tylko gdy koszyk ma produkty i smyczy jeszcze w nim nie ma
    if (upsellEl) upsellEl.hidden = !hasItems || upsellInCart;
  }

  /* ---------- API ---------- */
  function refresh() {
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        return loadCompareData(cart).then(function () {
          render(cart); updateBubble(); return cart;
        });
      });
  }

  function changeLine(key, quantity) {
    itemsEl.classList.add('bl-cart-busy');
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { return loadCompareData(cart).then(function () { render(cart); updateBubble(); }); })
      .finally(function () { itemsEl.classList.remove('bl-cart-busy'); });
  }

  // Ustawia laczna ilosc wariantu rozbitego na kilka linii: pierwsza linia dostaje
  // cala ilosc, pozostale 0 — Shopify sam rozbije je ponownie wedlug rabatu.
  function setGroup(g, quantity) {
    if (g.keys.length === 1) return changeLine(g.keys[0], quantity);
    var updates = {};
    g.keys.forEach(function (k, n) { updates[k] = n === 0 ? quantity : 0; });
    itemsEl.classList.add('bl-cart-busy');
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { return loadCompareData(cart).then(function () { render(cart); updateBubble(); }); })
      .finally(function () { itemsEl.classList.remove('bl-cart-busy'); });
  }

  function addVariant(id) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    }).then(function () { return refresh(); });
  }

  function updateBubble() {
    // licznik przy ikonie koszyka w nagłówku bellia
    if (cartState) {
      document.querySelectorAll('[data-bl-cart-bubble]').forEach(function (b) {
        b.textContent = cartState.item_count;
        b.hidden = cartState.item_count === 0;
      });
    }
  }

  /* ---------- otwieranie / zamykanie ---------- */
  function open() {
    overlay.hidden = false;
    panel.hidden = false;
    void panel.offsetWidth; // wymuszony reflow, by transycja zadziałała bez rAF
    overlay.classList.add('is-open');
    panel.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
    startTimer();
    refresh();
  }

  function close() {
    overlay.classList.remove('is-open');
    panel.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    setTimeout(function () { overlay.hidden = true; panel.hidden = true; }, 300);
  }

  /* ---------- licznik rezerwacji ---------- */
  function startTimer() {
    if (!timerEl || !reserveMinutes) return;
    var end = parseInt(sessionStorage.getItem('pzCartTimerEnd') || '0', 10);
    var now = Date.now();
    if (!end || end <= now) {
      end = now + reserveMinutes * 60000;
      sessionStorage.setItem('pzCartTimerEnd', String(end));
    }
    clearInterval(timerInterval);
    var tick = function () {
      var left = Math.max(0, Math.floor((end - Date.now()) / 1000));
      var m = String(Math.floor(left / 60)).padStart(2, '0');
      var s = String(left % 60).padStart(2, '0');
      timerEl.textContent = m + ':' + s;
      if (left <= 0) {
        end = Date.now() + reserveMinutes * 60000;
        sessionStorage.setItem('pzCartTimerEnd', String(end));
      }
    };
    tick();
    timerInterval = setInterval(tick, 1000);
  }

  /* ---------- init ---------- */
  function init() {
    root = document.querySelector('[data-bl-cart]');
    if (!root) return;
    panel = root.querySelector('[data-bl-cart-panel]');
    overlay = root.querySelector('[data-bl-cart-overlay]');
    itemsEl = root.querySelector('[data-bl-cart-items]');
    scrollEl = root.querySelector('[data-bl-cart-scroll]');
    emptyEl = root.querySelector('[data-bl-cart-empty]');
    footEl = root.querySelector('[data-bl-cart-foot]');
    countEl = root.querySelector('[data-bl-cart-count]');
    subtotalEl = root.querySelector('[data-bl-cart-subtotal]');
    timerEl = root.querySelector('[data-bl-cart-timer]');
    protectInput = root.querySelector('[data-bl-cart-protect]');
    savingsEl = root.querySelector('[data-bl-cart-savings]');
    savingsValueEl = root.querySelector('[data-bl-cart-savings-value]');
    upsellEl = root.querySelector('[data-bl-cart-upsell]');
    upsellSelect = root.querySelector('[data-bl-cart-upsell-variant]');
    upsellImg = root.querySelector('[data-bl-upsell-cart-img]');

    moneyFormat = root.getAttribute('data-money-format') || '';
    protectionVariant = parseInt(root.getAttribute('data-protection-variant') || '0', 10) || 0;
    reserveMinutes = parseInt(root.getAttribute('data-reserve-minutes') || '0', 10) || 0;
    upsellHandle = root.getAttribute('data-upsell-handle') || '';

    // upsell: podmiana zdjęcia przy zmianie wariantu + dodanie do koszyka
    if (upsellSelect && upsellImg && upsellSelect.tagName === 'SELECT') {
      var syncUpsellImg = function () {
        var opt = upsellSelect.options[upsellSelect.selectedIndex];
        var src = opt ? opt.getAttribute('data-img') : null;
        if (src && upsellImg.getAttribute('src') !== src) upsellImg.src = src;
      };
      upsellSelect.addEventListener('change', syncUpsellImg);
      syncUpsellImg();
    }
    var upsellAddBtn = root.querySelector('[data-bl-cart-upsell-add]');
    if (upsellAddBtn && upsellSelect) {
      upsellAddBtn.addEventListener('click', function () {
        var id = parseInt(upsellSelect.value, 10);
        if (!id) return;
        upsellAddBtn.disabled = true;
        var label = upsellAddBtn.textContent;
        upsellAddBtn.textContent = 'Dodaję…';
        addVariant(id).finally(function () {
          upsellAddBtn.disabled = false;
          upsellAddBtn.textContent = label;
        });
      });
    }

    root.querySelectorAll('[data-bl-cart-close]').forEach(function (b) { b.addEventListener('click', close); });
    overlay.addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !panel.hidden) close(); });

    // delegacja: ilości i usuwanie
    itemsEl.addEventListener('click', function (e) {
      var removeBtn = e.target.closest('[data-bl-remove]');
      var qtyBtn = e.target.closest('[data-bl-qty]');
      var row = e.target.closest('.bl-cart-item');
      if (!row) return;
      var g = grupyStanu[row.getAttribute('data-key')];
      if (!g) return;
      if (removeBtn) { setGroup(g, 0); return; }
      if (qtyBtn) {
        var next = g.qty + parseInt(qtyBtn.getAttribute('data-bl-qty'), 10);
        setGroup(g, Math.max(0, next));
      }
    });

    // ochrona przesyłki
    if (protectInput && protectionVariant) {
      protectInput.addEventListener('change', function () {
        if (protectInput.checked) {
          addVariant(protectionVariant);
        } else {
          var line = (cartState.items || []).find(function (i) { return i.variant_id === protectionVariant; });
          if (line) changeLine(line.key, 0);
        }
      });
    }

    // do kasy
    var checkoutBtn = root.querySelector('[data-bl-cart-checkout]');
    if (checkoutBtn) checkoutBtn.addEventListener('click', function () { window.location.href = '/checkout'; });

    // przechwycenie kliknięcia w ikonę koszyka / linki do /cart
    document.addEventListener('click', function (e) {
      var link = e.target.closest('a[href$="/cart"], a[href*="/cart?"], #cart-icon-bubble');
      if (!link) return;
      e.preventDefault();
      e.stopPropagation();
      open();
    }, true);

    // każde dodanie do koszyka (fetch na /cart/add) otwiera drawer
    var origFetch = window.fetch;
    window.fetch = function () {
      var url = typeof arguments[0] === 'string' ? arguments[0] : (arguments[0] && arguments[0].url) || '';
      var p = origFetch.apply(this, arguments);
      if (url.indexOf('/cart/add') > -1) {
        p.then(function (res) {
          if (res.ok) setTimeout(open, 50);
        }).catch(function () {});
      }
      return p;
    };

    // zdarzenia zewnętrzne (np. buy box landinga)
    document.addEventListener('bellia:cart:open', open);

    refresh();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
